import { Form, Upload } from "antd";
import '../../../assets/scss/style.scss';
import CustomModal from "../../../hoc/CustomModal";
import { useEffect, useState } from "react";
import PopComponent from "../../popContent";
import { rules } from "../../../siteData/rules";
import CustomTextarea from "../../../component/CustomTextarea";

const CreateGroupPop = ({ categoryData, handleChange, handleClose, handleError, progress, setFormRef }) => {
    const [modalName, setModalName] = useState("UserPop");
    const [openModal, setModalOpen] = useState(false);
    const [error, setError] = useState({});
    let Modal = PopComponent[modalName];
    const [form] = Form.useForm();

    useEffect(() => {
        setFormRef(form);
    }, []);

    form.setFieldsValue({
        name: categoryData.name
    });

    const handleUpload = (file) => {
        if (file.size > 3096576) {
            handlePopModal('ErrorPop', { header: "Error", body: "File size must be less then 3 mb" })
            return Upload.LIST_IGNORE;
        } else if (!file.type.match(/png|jpeg|jpg/g)) {
            handlePopModal('ErrorPop', { header: "Error", body: "Please add only png, jpg or jpeg files" })
            return Upload.LIST_IGNORE;
        } else {
            handleError({ target: { name: "" } });
        }
    };

    const handlePopModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };

    return (
        <div className="modal_dialog">
            <div className="modal_body">
                <div className="add_thought_leader">
                    <Form
                        form={form}
                        name="register"
                        onReset={handleClose}
                        initialValues={categoryData}
                        scrollToFirstError
                        className="attached_courses-add_skill"
                    >
                        <h2>edit group</h2>
                        <Form.Item name="name" rules={rules.name} className="form_group">
                            <label>Group Name</label>
                            <input type="text" name='name' onChange={handleChange} className="form_control" />
                        </Form.Item>
                        <CustomTextarea
                            progress={progress}
                            label="Bio"
                            name="bio_raw"
                            onChange={handleChange}
                            customClass="form_label_multiple_option"
                            value={categoryData?.bio_raw}
                            errors={''}
                        />
                        <div class="form_group form_footer d_flex_center">
                            <button type="reset" class="btn btn_gray">cancel</button>
                            <button type="submit" class="btn btn_primary">create</button>
                        </div>
                    </Form>
                </div>
            </div>
            {Modal && (
                <CustomModal className={`${modalName === 'ErrorPop' ? 'ant-modal modal skill_model' : 'modal peak_model'} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleClose} open={openModal}>
                    <Modal
                        error={error}
                        handleOpenModal={handlePopModal}
                    />
                </CustomModal>
            )
            }
        </div>
    )
};

export default CreateGroupPop